import { SimData } from '../../constants/sim';

export type SimDataProps = (keyof SimData)[];

export const MOBILE_NETWORK_OPERATOR_SECTIONS_PROPS: SimDataProps = [
  'mobileNetworkOperator',
  'organisation',
  'dcpEnterprise',
  'commsPlan',
  'mnoStatus',
  'mnoStatusEntryTime',
  'mnoRatePlan',
];

export const SIM_PROFILES_SECTIONS_PROPS: SimDataProps = [
  'sessionStatus',
  'simType',
  'subscriptionStatus',
];

export const CLIENT_SECTIONS_PROPS: SimDataProps = [
  'accountName',
  'accountRef',
  'customerCommsPlan',
];

export const IDENTIFICATION_NUMBERS_SECTIONS_PROPS: SimDataProps = [
  'iccid',
  'imsi',
  'msisdn',
  'euicc',
];

export const SESSION_DETAILS_SECTIONS_PROPS: SimDataProps = [
  'sessionStatus',
  'sessionStatusLastUpdated',
  'sessionStartTime',
  'sessionEndTime',
  'apn',
  'localization',
  'rasClient',
  'framedProtocol',
  'nasIpAddress',
  'serviceType',
  'userName',
];

export const USAGE_SECTIONS_PROPS: SimDataProps = [
  'liveDataUsage',
  'inboundLiveDataUsage',
  'outboundLiveDataUsage',
  'inMinuteUsage',
  'outMinuteUsage',
  'inTextUsage',
  'outTextUsage',
];
